import {AfterViewInit, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConfigureWidgetTextComponent} from './configure-widget-text/configure-widget-text.component';
import {ConfigureWidgetTotalsComponent} from './configure-widget-totals/configure-widget-totals.component';
import {ConfigureWidgetPieChartComponent} from './configure-widget-pie-chart/configure-widget-pie-chart.component';
import {ConfigureWidgetTableComponent} from './configure-widget-table/configure-widget-table.component';
import {ConfigureWidgetAxisChartComponent} from './configure-widget-axis-chart/configure-widget-axis-chart.component';
import {ComponentType} from '@angular/cdk/portal';
import {AppState} from '../../../../shared/store/store';
import {Store} from '@ngrx/store';
import {dialogOpen} from '../../../../shared/store/dialog/dialog.actions';
import {DialogData} from "../../../../shared/interfaces/dialog";

@Component({
  selector: 'app-add-widget-dialog',
  templateUrl: './add-widget-dialog.component.html',
  styleUrls: ['./add-widget-dialog.component.scss']
})
export class AddWidgetDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  public dialogText: ComponentType<ConfigureWidgetTextComponent> = ConfigureWidgetTextComponent;
  public dialogTotals: ComponentType<ConfigureWidgetTotalsComponent> = ConfigureWidgetTotalsComponent;
  public dialogPieChart: ComponentType<ConfigureWidgetPieChartComponent> = ConfigureWidgetPieChartComponent;
  public dialogAxisChart: ComponentType<ConfigureWidgetAxisChartComponent> = ConfigureWidgetAxisChartComponent;
  public dialogTable: ComponentType<ConfigureWidgetTableComponent> = ConfigureWidgetTableComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: DialogData,
    public readonly dialogRef: MatDialogRef<AddWidgetDialogComponent>,
    private readonly _store: Store<AppState>
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  public openDialog(component: ComponentType<any>): void {
    this._store.dispatch(dialogOpen({
      component: component,
      keepParent: true,
      config: {
        width: '750px',
        height: 'auto'
      },
      data: this.data
    }))
  }
}
